import { Box, Button, FormLabel, IconButton, Modal } from '@mui/material';
import React from 'react';
import { CSVLink } from 'react-csv';
import Iconify from '../../iconify/Iconify';
import '../../../css/style.css';

function Newuser(props) {
  const { modelopen, handleClose, typeError, handleFile, handelok, Filename, name, errormessage, errordata, error } =
    props;

  const header = [
    {
      Name: 'Hardik',
      'Employer Name': 'Tata',
      'Employment type': 'Full-Time',
      'Employee Risk Category': '0',
      'Employer Risk Category': '0',
      'Employee email id': 'hardik@tata.com',
      Designation: 'Manager',
      City: 'Mumbai',
      'Year of joining': '2012',
      'Employment Status (permanent/probation/trainee/contract/notice period)': 'permanent',
      'Phone number': '1234347890',
      Bank: 'SBI',
      'Bank Acc No': '202233123556',
      'IFSC Number': '0',
      'PAN Number': 'addrf7789',
      'Adhar Card': 'manager',
      'Employee stock / ESOPs': '0',
      Month: `202301`,
      Paydays: '28',
      'Net Salary': '100000',
      'Gross Salary': '0',
      'Fixed Salary': '40000',
      'Fixed Variable Salary': '10000',
      Bonus: '0',
      Deductions: '5000',
      'LOP Days': '0',
      Overtime: '0',
      Allowance: '0',
      Arrears: '0',
      Reimbursements: '0',
      'Relocation Expenses': '0',
      'loan EMI from company': '60000',
      'company credit card usage': '0',
      'Advance in lieu of company expenses': '0',
      'Year end settlements': '0',
      // 'Loss of Pay days': '0',
      'Resignation Date': '0',
      'Notice period': '0',
      Terminated: '0',
      'On Probation': '0',
      'probation period': '0',
      'On sabbatical': '0',
      'Sabbatical period': '0',
      'Employee outstanding': '15000',
      'Last date of employment': '0',
    },
  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
  };

  return (
    <>
      {/* New Users */}

      <Modal
        open={modelopen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ fontSize: '18px', fontWeight: '700' }}>Upload {name} file</div>
            <IconButton size="small" color="inherit" onClick={handleClose}>
              <Iconify icon={'material-symbols:close'} />
            </IconButton>
          </div>
          <CSVLink style={{ color: 'white', textDecoration: 'none' }} data={header} filename="User.csv" target="">
            <Button style={{ marginTop: '20px' }} variant="contained">
              Download Sample
            </Button>
          </CSVLink>
          <Box style={{ marginTop: '10px' }}>
            <form>
              <FormLabel className="file-input__label" htmlFor="file-input">
                <Iconify icon={'material-symbols:upload-sharp'} />
                <Box>Upload File</Box>
                <Box sx={{ fontSize: '14px' }}>{Filename}</Box>
                <input type="file" id="file-input" className="file-input__input" required onChange={handleFile} />
              </FormLabel>
              <input type="file" id="file-input" className="file-input__input" required onChange={handleFile} />
            </form>
            {typeError && (
              <div style={{ color: 'red' }} className="alert alert-danger" role="alert">
                {typeError}
              </div>
            )}
          </Box>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ paddingTop: '10px', width: '100%', color: 'red' }}>{errormessage}</Box>
            <CSVLink style={{ color: 'white', textDecoration: 'none' }} data={errordata} filename="Error.csv" target="">
              <Button
                style={{ marginTop: '10px', backgroundColor: 'red' }}
                className={error ? 'text-nowrap' : 'hidden '}
                variant="contained"
              >
                Download csv
              </Button>
            </CSVLink>
          </Box>

          <Button style={{ marginTop: '10px', width: '100%' }} onClick={handelok} variant="contained">
            UPLOAD
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default Newuser;
